import { useNavigate } from 'react-router-dom';

import { useAuthContext } from '@auth_module/context/AuthContext';

type UseSuccessfulLoginProps = {
  navigateTo: string;
};

export const useSuccessfulLogin = ({ navigateTo }: UseSuccessfulLoginProps) => {
  const navigate = useNavigate();
  const { auth, setAuth } = useAuthContext();

  function handleSuccessLogin(token: string, castedAdmin?: string) {
    setAuth({
      ...auth,
      token,
      castedAdmin,
    });

    // redirect(); // Temporary redirection to ADC cloudfront.
    navigate(navigateTo);
  }

  return { handleSuccessLogin };
};
